import i18n from '@/i18n'
export const columns = [
    {
        columnId: 1,
        name: i18n.t('OrderBill.OrderBill15'),
        key: "handle",
        width: "110",
    },
    {
        columnId: 2,
        name: i18n.t('orderList.orderList2'),
        key: "splitOrderId",
        width: 70,
    },
    // {
    //     columnId: 3,
    //     name: i18n.t('OrderDetail.OrderDetail3'),
    //     key: "tongkunNo",
    //     width: 90,
    // },
    {
        columnId: 3,
        name: i18n.t('defe.defe3'),
        key: "createTime",
        minWidth: 120,
    },
    {
        columnId: 4,
        name: i18n.t('OrderBill.OrderBill16'),
        key: "trackingNumberCn",
        minWidth: 120,
    },
    // {
    //     columnId: 5,
    //     name: i18n.t('OrderBill.OrderBill17'),
    //     key: "trackingNumberJpn",
    //     minWidth: 120,
    // },
    {
        columnId: 6,
        name: i18n.t('orderList.orderList46'),
        key: "orderStatus",
        width: 100,
    },
    // {
    //     columnId: 7,
    //     name: "颜色",
    //     key: "colour",
    // },
    // {
    //     columnId: 8,
    //     name: "尺寸",
    //     key: "goodsSize",
    // },
    // {
    //     columnId: 9,
    //     name: "品番",
    //     key: "goodsNumber",
    // },
    {
        columnId: 7,
        name: i18n.t('createOrder.createOrder13'),
        key: "shopInfo",
        minWidth: 130,
    },
    {
        columnId: 8,
        name: i18n.t('orderList.orderList118'),
        key: "price",
        minWidth: 80,
    },
    {
        columnId: 9,
        name: i18n.t('orderList.orderList119'),
        key: "chineseFreightFee",
        minWidth: 80,
    },
    // {
    //     columnId: 10,
    //     name: "商品数量",
    //     key: "goodsCount",
    // },
    // {
    //     columnId: 11,
    //     name: "待装箱数",
    //     key: "waitBoxCount",
    // },
    // {
    //     columnId: 12,
    //     name: "退货数量",
    //     key: "refundCount",
    // },
    // {
    //     columnId: 13,
    //     name: "销毁数量",
    //     key: "destroyCount",
    // },
    {
        columnId: 10,
        name: i18n.t('orderList.orderList29'),
        key: "shopNum",
        minWidth: 130,
    },
    {
        columnId: 14,
        name: i18n.t('OrderBill.OrderBill18'),
        key: "inspection",
        minWidth: 100,
    },
    {
        columnId: 15,
        name: i18n.t('orderList.orderList47'),
        key: "categoryFlag",
        width: "80",
    },
    {
        columnId: 16,
        name: i18n.t('createOrder.createOrder27'),
        key: "putIntent",
        width: "70",
    },
    {
        columnId: 17,
        name: i18n.t('feedback.feedback9'),
        key: "pictureUrl",
        minWidth: "85",
    },
    {
        columnId: 18,
        name: i18n.t('createOrder.createOrder100'),
        key: "orderType",
        width: "70",
    },
    {
        columnId: 19,
        name: i18n.t('OrderBill.OrderBill19'),
        key: "badInfo",
        minWidth: "120",
    },
    // {
    //     columnId: 19,
    //     name: "不良待处理",
    //     key: "badCount",
    // },
    // {
    //     columnId: 20,
    //     name: "补发中",
    //     key: "reissueCount",
    // },
    // {
    //     columnId: 21,
    //     name: "换货中",
    //     key: "exchangCount",
    // },
];
